import React, { useEffect, useMemo, useState } from "react";
import SearchBar from "./components/SearchBar";
import { Card, Pagination, Skeleton } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import "@/pages/a.css";
import { EmptyComponent } from "@/components/ui/EmptyComponent";

import JobService from "@/services/JobService";

import { JobCard } from "@/pages/job/components/JobCard";
import { Fragment } from "react";

const Job = () => {

    const ITEM_PER_PAGE = 10;
    const [current, setCurrent] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [jobs, setJobs] = useState([]);
    const [jobsPage, setJobsPage] = useState([]);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const queryParams = useMemo(() => {
        return Object.fromEntries(searchParams.entries());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams.toString()]);


    useEffect(() => {
        setLoading(true)
        JobService.getQuery(queryParams).then(res => {
            setJobs(res)
            setTotalPage(res.length)
            setLoading(false)
        }).catch(error => {
            console.error(error)
            setLoading(false)
        })
    }, [queryParams]);

    useEffect(() => {
        setJobsPage(jobs.slice((current - 1) * ITEM_PER_PAGE, current * ITEM_PER_PAGE))
    }, [current, jobs]);

    const handleSearch = (query) => {
        navigate(`?${new URLSearchParams(query).toString()}`)
    }

    const onChange = (page) => {
        setCurrent(page);
    };

    return (
        <div className={"bg-gray-100"}>
            <div className={"container px-4 sm:px-8 mx-auto lg:px-22 pt-12"}>
                <div className={"bg-white rounded-xl"}>
                    <div className={"flex justify-between"}>
                        <div
                            className={
                                "w-full rounded-t-xl p-5 bg-gradient-to-tl from-green-400 via-green-500 to-green-700 animate-gradient"
                            }
                            style={{
                                backgroundSize: "200% 200%",
                                animation: "gradient-animation 6s ease infinite",
                            }}
                        >
                            <h1 className={"text-3xl font-bold text-white drop-shadow-md"}>Tìm việc làm</h1>
                            <p className={"text-gray-200 text-lg drop-shadow-sm"}>Tìm kiếm việc làm phù hợp với bản
                                thân</p>
                        </div>

                    </div>
                    <SearchBar onSearch={handleSearch} />
                    <div className={"p-4 container mx-auto"}>
                        <h2 className={""}>Tìm thấy <b>{totalPage}</b> việc làm phù hợp với bạn</h2>
                    </div>
                    <div className="border-t border-gray-200 container p-2">
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
                            {/* Danh sách công việc */}
                            <div className="col-span-full md:col-span-3">
                                {loading ? (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        {[...Array(ITEM_PER_PAGE)].map((_, index) => (
                                            <Skeleton key={index} active />
                                        ))}
                                    </div>
                                ) : jobs.length > 0 ? (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        {jobsPage.map((job, index) => (
                                            <Fragment key={index}><JobCard index={index} job={job} /></Fragment>
                                        ))}
                                        <div className="col-span-full flex justify-center">
                                            {totalPage > ITEM_PER_PAGE && (
                                                <Pagination
                                                    current={current}
                                                    onChange={onChange}
                                                    total={totalPage}
                                                    pageSize={ITEM_PER_PAGE}
                                                    showSizeChanger={false}
                                                />
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <EmptyComponent description="công việc" />
                                )}
                            </div>

                            {/* Aside */}
                            <div className="aside hidden lg:block md:col-span-1">
                                <Card
                                    className="rounded-lg shadow-md"
                                    style={{ width: "80%", margin: "0 auto" }} // Giảm chiều rộng của aside
                                >
                                    <img
                                        src="https://i.pinimg.com/736x/26/ad/de/26adde6fefddb888d08d568a03c16432.jpg"
                                        alt="quảng cáo"
                                        className="rounded-lg p-0"
                                    />
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Job;
